import React, { Component } from 'react'
import { connect } from 'react-redux'

import { isValidString, validateUrl } from '../../../utils/string'

import { getShopList } from '../../../actions/shop'
import { getWebHooks, updateWebHook, createWebHook } from '../../../actions/integration'
import { openErrorMessage } from '../../../actions/message'

import ContainerWithTitleWrapper from '../../HOC/ContainerWithTitle'
import WebHooksList from '../../../components/WebHooks/WebHooksList'

class WebHooks extends Component {
  componentDidMount() {
    this.props.dispatch(getShopList())
    this.props.dispatch(getWebHooks())
  }

  onSave = (data, afterOnSave) => {
    /* if(!isValidString(data.url) || !validateUrl(data.url)) {

            this.props.dispatch(openErrorMessage('Please add a valid url'))

            return;
        } */

    let error = ''
    for (let i in (data.webHookUrls && data.webHookUrls) || []) {
      if (!isValidString(data.webHookUrls[i] || !validateUrl(data.webHookUrls[i]))) {
        error = 'Provide a valid url'
        break
      }
    }

    if (error) {
      this.props.dispatch(openErrorMessage(error))

      return
    }

    const apiToHit = data.id ? updateWebHook : createWebHook

    this.props.dispatch(apiToHit(data)).then((response) => {
      this.props.dispatch(getWebHooks())
      afterOnSave(response)
    })
  }

  render() {
    const { shopsList = {} } = this.props.shopReducer

    const shopLastModified = this.props.shopReducer.lastModified

    const { webHooksList = {}, lastModified = null } = this.props.integrationReducer

    const shopListValues = shopsList.values || []
    const webHooksListValues = webHooksList.values || []

    // update the underlying compoent on either store changes
    const modifiedAt = Math.max(shopLastModified, lastModified)

    return (
      <div>
        <WebHooksList
          shops={shopListValues}
          webHooks={webHooksListValues}
          lastModified={modifiedAt}
          onSave={this.onSave}
        />
      </div>
    )
  }
}

const WebHooksWithTitle = ContainerWithTitleWrapper(WebHooks, 'Webhook Management')
const WebHooksConnected = connect(({ shopReducer, integrationReducer, dispatch }) => ({
  shopReducer,
  integrationReducer,
  dispatch,
}))(WebHooksWithTitle)

export default WebHooksConnected



// WEBPACK FOOTER //
// ./src/containers/Settings/Integration/WebHooks.js